import { Action, createReducer, on } from '@ngrx/store';

import { UtilitiesActions } from './utilities.actions';

export const UTILITIES_FEATURE_KEY = 'utilities';

export interface UtilitiesState {
  count: number;
}

export interface UtilitiesPartialState {
  readonly [UTILITIES_FEATURE_KEY]: UtilitiesState;
}

export const initialUtilitiesState: UtilitiesState = { count: 0 };

const reducer = createReducer(
  initialUtilitiesState,
  on(UtilitiesActions.progress, (state) => ({
    ...state,
    count: state.count + 1,
  })),
  on(UtilitiesActions.complete, (state) => ({
    ...state,
    count: state.count - 1,
  })),
);

export function utilitiesReducer(
  state: UtilitiesState | undefined,
  action: Action,
) {
  return reducer(state, action);
}
